// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Lx","content":"Mx","crumbsList":"Nx","dropdownsWrap":"Ox"};